"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSubscriber = createSubscriber;
function createSubscriber(socket, event, listener) {
    socket.on(event, listener);
}
